import { extractLastNameComponent } from '@spotify/confidence-core-react';
import {
  ActivityChangeOptions,
  ActivityTagItem,
  createActivityChangeExtension,
} from '@spotify/plugin-confidence-activity-react';
import { useIdentity } from '@spotify/plugin-confidence-iam-react';

const toIdentityName = (value: unknown): string | undefined => {
  if (typeof value === 'string') return value;
  if (typeof value === 'object' && value !== null) {
    const obj = value as Record<string, unknown>;
    if (typeof obj.name === 'string') return obj.name;
  }
  return undefined;
};

const useDisplayName = (value: unknown): string => {
  const identityName = toIdentityName(value);
  const { identity } = useIdentity({
    name: identityName ?? '',
    skip: !identityName,
  });
  return (
    identity?.displayName ?? extractLastNameComponent(identityName) ?? 'Unknown'
  );
};

const OwnerUpdates = ({ change }: ActivityChangeOptions) => {
  const oldName = useDisplayName(change.oldValue);
  const newName = useDisplayName(change.newValue);

  return <ActivityTagItem oldValue={oldName} newValue={newName} />;
};

export const OWNER_CHANGE_EXTENSION = createActivityChangeExtension({
  id: 'owner-change',
  predicate: ({ change }) => change.fieldPath === '/owner',
  render: OwnerUpdates,
  values: change => ({
    oldValue: { owner: change.oldValue },
    newValue: { owner: change.newValue },
  }),
});
